#import "../fragments/event-fragment-sparse.graphql"
#import "../fragments/pinned-info-fragment.graphql"

query GetPinnedEvents($input: TimelineEventsPinnedInput!) {
    pinnedEvents(input: $input) {
        edges {
            node {
                ...EventFragmentSparse
            }
            pinnedInfo {
                ...PinnedInfoFragment
            }
        }
    }
}
